
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Valence dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Valence certifiée Google Partner, accompagne les entreprises valentinoises pour accroître leur visibilité en ligne et développer leur base de clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Valence dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Valence certifiée Google Partner, accompagne les entreprises valentinoises pour accroître leur visibilité en ligne et développer leur base de clients.",
        },
      ],
    };
  },
};
